import { render, staticRenderFns } from "./DblogsSingle.vue?vue&type=template&id=057eac52"
import script from "./DblogsSingle.vue?vue&type=script&lang=js"
export * from "./DblogsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports